import { RealtimeMessageType } from '../../../features/realtime/realtime.types';
import * as realtime from '../../../features/realtime/realtime.slice';
import {
  type FileTransferEventData,
  type FileTransferEventName,
} from '../../../features/fileTransfer/fileTransfer.type';
import { store } from '../../../stores/redux';

export const sendFileTransferRealtimeMessage = async <
  T extends FileTransferEventName,
>(
  ids: string[],
  eventName: T,
  eventData?: FileTransferEventData[T],
): Promise<void> => {
  if (ids.length === 0) {
    throw new Error(
      `sendFileTransferRealtimeMessage: id is undefined for ${eventName}`,
    );
  }

  const message = {
    messageType: RealtimeMessageType.FileTransferRequest,
    payload: { eventName, eventData },
  };

  if (ids.length === 1 && ids[0]) {
    await store.dispatch(
      realtime.sendMessage({
        id: ids[0],
        message,
      }),
    );
  }

  await store.dispatch(
    realtime.sendMessageMany({
      ids,
      message,
    }),
  );
};
